import React from 'react'
import FontDropDown from './fontDropDown.jsx'
import ThemeDropDown from './themeDropDown.jsx'
import ToggleBtn from './toggleBtn.jsx'
import IconButton from './iconButton.jsx'
import ColorPickerButton from './colorPickerButton.jsx'
import LinkPicker from './linkPicker.jsx'
import FixedButtonContextMenu from './fixedButtonContextMenu.jsx'
import TextPopup from './textPopup.jsx'
import LabeldSlider from './labeldSlider.jsx'
import LineHeight from './lineHeight.jsx'
import _ from 'lodash'

function getAlignment(commandStates) {
    switch (true) {
        case commandStates.justifyleft: return 'left'
        case commandStates.justifyright: return 'right'
        case commandStates.justifycenter: return 'center'
        case commandStates.justifyblock: return 'block'
    }

    return 'left'
}

function getListType(commandStates) {
    switch (true) {
        case commandStates.bulletedlist: return 'bullets'
        case commandStates.numberedlist: return 'numbers'
    }

    return 'none'
}

function getListCommand(listType) {
    switch (listType) {
        case 'bullets': return 'bulletedlist'
        case 'numbers': return 'numberedlist'
    }
}

function buildCommandState(commandStates) {
    return {
        direction: commandStates.bidirtl ? 'right' : 'left',
        alignment: getAlignment(commandStates),
        listType: getListType(commandStates)
    }
}

function loadRequiredScss() {
    require('./scss/richtextToolbar.scss')
}

class RichTextToolbar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            commands: buildCommandState(props.commandStates)
        }

        loadRequiredScss()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({commands: buildCommandState(nextProps.commandStates)})
    }

    toggleTextDirection() {
        if (this.state.commands.direction === 'right') {
            this.props.execCommand('bidiltr')
        } else {
            this.props.execCommand('bidirtl')
        }
    }

    getIconName(prefix) {
        let direction = this.state.commands.direction || 'left'

        direction = direction[0].toUpperCase() + direction.slice(1)

        return prefix + direction
    }

    handleAlignmentChanged(val) {
        this.props.execCommand('justify' + val)
    }

    handleListChanged(val) {
        let command = null

        if (val === 'none') {
            command = getListCommand(this.state.commands.listType)
        } else {
            command = getListCommand(val)
        }

        if (command) {
            this.props.execCommand(command)

        }
    }

    getListTypeOptions() {
        return [
            {value: 'none', symbol: 'textListNone', maskSymbol: 'textListBullets' + (this.state.commands.direction === 'right' ? 'Right' : '')},
            {value: 'bullets', symbol: 'textListBullets' + (this.state.commands.direction === 'right' ? 'Right' : '')},
            {value: 'numbers', symbol: 'textListNumbers' + (this.state.commands.direction === 'right' ? 'Right' : '')}
        ]
    }

    getAlignmentOptions() {
        return [
            {value: 'left', symbol: 'textAlignLeft'},
            {value: 'right', symbol: 'textAlignRight'},
            {value: 'center', symbol: 'textAlignCenter'},
            {value: 'block', symbol: 'textAlignBlock'}
        ]
    }

    handleValueChanged(cmdName, val, unit = 'em') {
        this.props.execCommand(cmdName, val + unit, {execWithoutFocus: true})
    }

    focus() {
        this.props.focus()
    }

    getChildContext() {
        return {translateFromContext: key => this.props.translate(key) || `!${key}!`}
    }

    render() {
        return (
            <div className="wix-richtext-toolbar-wrapper">
                <div className="toolbar-section">
                    <ThemeDropDown execCommand={this.props.execCommand} value={_.get(this.props.commandStates.formatBlock, 'class')} themes={this.props.themes} translate={this.props.translate}/>
                    <FontDropDown fonts={this.props.fonts} execCommand={this.props.execCommand} value={this.props.commandStates.fontFamily} translate={this.props.translate}/>
                    <TextPopup width={71} label={this.props.commandStates.fontSize + ' px'} automationId="font-size-button">
                        <LabeldSlider
                            value={this.props.commandStates.fontSize}
                            label={this.props.translate('font_slider_label')}
                            onChange={val => this.handleValueChanged('fontSize', val, 'px')}
                            onSlideEnd={() => this.focus()}
                            min={6} max={176}/>
                    </TextPopup>
                    <ToggleBtn automationId="bold-button" cmdName="bold" label="textBold" value={this.props.commandStates.bold} disabled={this.props.disabled} execCommand={this.props.execCommand}/>
                    <ToggleBtn automationId="italic-button" cmdName="italic" label="textItalic" value={this.props.commandStates.italic} disabled={this.props.disabled} execCommand={this.props.execCommand}/>
                    <ToggleBtn automationId="underline-button" cmdName="underline" label="textUnderline" value={this.props.commandStates.underline} disabled={this.props.disabled} execCommand={this.props.execCommand}/>
                    <ColorPickerButton automationId="foreColor-button" value={this.props.commandStates.foreColor} commandName="foreColor" execCommand={this.props.execCommand}/>
                    <ColorPickerButton automationId="backColor-button" value={this.props.commandStates.backColor} commandName="backColor" execCommand={this.props.execCommand}/>
                    <LinkPicker automationId="link-button" value={this.props.commandStates.wixLink} execCommand={this.props.execCommand} openLinkDialog={this.props.openLinkDialog} disabled={this.props.disabled} expandLinkSelection={this.props.expandLinkSelection}/>
                    <IconButton automationId="reset-style-button" symbol="textRemoveFormat" disabled={this.props.disabled} onClick={() => this.props.execCommand('resetThemeAndStyles')}/>
                </div>
                <div className="toolbar-divider" />
                <div className="toolbar-section">
                    <FixedButtonContextMenu
                        automationId="alignment-button"
                        onChange={val => this.handleAlignmentChanged(val)}
                        options={this.getAlignmentOptions()}
                        value={this.state.commands.alignment}/>
                    <FixedButtonContextMenu
                        automationId="list-button"
                        onChange={val => this.handleListChanged(val)}
                        options={this.getListTypeOptions()}
                        value={this.state.commands.listType}/>
                    <IconButton automationId="outdent-button" symbol={this.getIconName('textOutdent')} disabled={this.props.disabled || this.props.commandStates.outdent === 0} onClick={() => this.props.execCommand('outdent')}/>
                    <IconButton automationId="indent-button" symbol={this.getIconName('textIndent')} disabled={this.props.disabled || this.props.commandStates.indent === 0} onClick={() => this.props.execCommand('indent')}/>
                    <TextPopup iconName="textLineHeight" automationId="line-height-button">
                        <LineHeight value={this.props.commandStates.lineHeight} execCommand={this.props.execCommand} onSlideEnd={() => this.focus()} translate={this.props.translate}/>
                    </TextPopup>
                    <TextPopup iconName="textCharSpacing" automationId="spacing-button">
                        <LabeldSlider
                            value={parseFloat(this.props.commandStates.letterSpacing)}
                            label={this.props.translate('letterspacing_slider_label')}
                            onChange={val => this.handleValueChanged('letterSpacing', val, 'em')}
                            onSlideEnd={() => this.focus()}
                            min={-0.1} max={0.7} step={0.05}/>
                    </TextPopup>
                    <IconButton automationId="text-direction-button" symbol={this.getIconName('textWriteDirection')} onClick={() => this.toggleTextDirection()}/>
                </div>
            </div>
        )
    }
}

RichTextToolbar.childContextTypes = {
    translateFromContext: React.PropTypes.func
}

RichTextToolbar.propTypes = {
    execCommand: React.PropTypes.func.isRequired,
    focus: React.PropTypes.func.isRequired,
    commandStates: React.PropTypes.object.isRequired,
    openLinkDialog: React.PropTypes.func,
    expandLinkSelection: React.PropTypes.func,
    translate: React.PropTypes.func.isRequired,
    fonts: React.PropTypes.object.isRequired
}

module.exports = RichTextToolbar



// WEBPACK FOOTER //
// ./src/components/toolbar/richTextToolbar.jsx